const ResetPassword = () => import(/* webpackChunkName: "resetpassword" */ '@/views/ResetPassword.vue')
export const reset = {
    path: '/auth/password/reset/:token',
    name: 'resetpassword',
    component: ResetPassword,
    meta: {
      requiresAuth: false
    }
  }